import React, { useCallback } from 'react';
import { Box, Text, Avatar, DropButton } from 'grommet';
import PropTypes from 'prop-types';
import CompanyDrop from 'granite-admin/core/components/UserDropMenu/components/CompanyDrop';
import ImageView from 'granite-admin/core/components/ImageView';
import { resetMyOrganisations } from 'granite-admin/utils/auth-singleton';
// import { ConfigContext } from 'granite-admin/core/components/ConfigProvider';
// import { getAuthToken } from 'granite-admin/utils/auth-singleton';

const getOrganisationAvatar = userProfile => {
  if (Boolean(userProfile) === false) return;
  const {
    profileImage
  } = userProfile;
  return profileImage ? /*#__PURE__*/React.createElement(ImageView, {
    src: profileImage,
    size: "30px",
    rounded: true
  }) : /*#__PURE__*/React.createElement(Avatar, {
    background: "#2D6E16",
    size: "30px",
    round: "full"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "white",
    size: "small"
  }, userProfile.firstName.charAt(0).toUpperCase()));
};
const UserDropMenu = ({
  userProfile,
  signOut,
  history,
  dispatch
}) => {
  const projectName = process.env.REACT_APP_PROJECT_NAME || 'Granite';
  const backToBusiness = useCallback(() => {
    dispatch({
      type: 'accounts/workspace/RESET_WORKSPACE'
    });
    dispatch({
      type: 'organisations/UPDATE_SELECTED_ORGANISATION',
      data: {}
    });
    dispatch({
      type: 'organisations/UPDATE_ORGANISATIONS',
      data: null
    });
    dispatch({
      type: 'accounts/sidebar/RESET_SIDEBAR',
      data: []
    });
    resetMyOrganisations();
    document.title = `${projectName}`;
    history.push('/dashboard');
  }, [dispatch, history, projectName]);
  return /*#__PURE__*/React.createElement(DropButton, {
    dropAlign: {
      top: 'bottom',
      right: 'right'
    },
    dropContent: /*#__PURE__*/React.createElement(CompanyDrop, {
      history: history,
      signOut: signOut,
      showMyBoardBtn: true,
      backToBusiness: backToBusiness
    }),
    dropProps: {
      style: {
        backgroundColor: '#fff',
        transition: 'all 0.5s ease 0s',
        borderRadius: '6px',
        boxShadow: 'rgb(0 0 0 / 10%) 0px 4px 17px 6px'
      }
    }
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    align: "center",
    gap: "small",
    pad: {
      right: 'small'
    }
  }, /*#__PURE__*/React.createElement(Text, null, userProfile.firstName), getOrganisationAvatar(userProfile)));
};
UserDropMenu.propTypes = {
  userProfile: PropTypes.object,
  signOut: PropTypes.func,
  history: PropTypes.object,
  dispatch: PropTypes.func
};
export default UserDropMenu;
export { getOrganisationAvatar };